import { logger } from './logger.util'

/**
 * Plays an audio file from the given URL.
 * Non-blocking fire-and-forget — errors are caught and logged
 * to avoid disrupting the calling code flow.
 */
export const playSound = (url: string): void => {
  try {
    const audio = new Audio(url)
    audio.play().catch((error: unknown) => {
      logger.warn('Sound playback blocked or failed:', error)
    })
  } catch (error: unknown) {
    logger.warn('Failed to create audio instance:', error)
  }
}
